// /**
//  * Session related apis
//  */

// import axios from 'axios';

// import { getRequestConfig } from './config';
// import Vue from 'vue';

// import { 
//   OK
// } from './ajaxActionResponse';
// import { 
//  REQUEST_WATCHLIST_ACTION, SAVE_WATCHLIST_ACTION,  LOGIN_ACTION, LOGOUT_ACTION, 
//  REQUEST_ININITIAL_MESSAGE, PING_ACTION, SAVE_STATE_ACTION, ENTER_PATIENT_CHART_ACTION,
//  EXIT_PATIENT_CHART_ACTION,INVITE_PATIENT_ACTION,UNINVITE_PATIENT_ACTION, SHARE_ACQUIRE_ACTION,
//  SHARE_SUMMARY_ACTION,
//  ASSIGN_PROV_ACTION
// } from './ajaxActions';
// import { request,inRequest } from './request';

// export function requestVitalSignsCodes() {
//   const config = getRequestConfig(null, 'requestVitalSignsCodes', '/session/requestVitalSignsCodes');
//   return new Promise((resolve, reject) => {
//     request(config)
//     .then((response) => {
//       if (response.data.status === OK) {
//         resolve(response.data.data.codes);
//       } else {
//         reject('Unable to retrieve vital sign codes');
//       }
//     })
//   });
// }

// export function getAllData() {
//   const config = getRequestConfig(null, 'getAllData');
//   return new Promise((resolve, reject) => {
//     request(config)
//     .then((response) => {
//       const { data } = response;
//       if (data) {
//         resolve(data);
//       } else {
//         reject('Unable to retrieve application data');
//       }
//     })
//   });
// }

// /**
//  * Pings server to check session status 
//  */
// export function ping() {
//   if(inRequest()) {
//     // no op
//     let p = new Promise((resolve) => {
//       resolve();
//     });
//     return p;
//   }
//   const config = getRequestConfig(null, PING_ACTION, '/session/ping');

//   return new Promise((resolve, reject) => {
//     request(config)
//       .then((response) => {
//         if (response.data.status === OK) {
//           resolve();
//         } else {
//           reject('Ping: Session timed out');
//         }
//       })
//   });
// };

// export function summaryByExternalId(id) {
//   let payload = { externalId: id };
//   const config = getRequestConfig(payload,SHARE_SUMMARY_ACTION,'/session/summaryByExternalId');
//   return new Promise((resolve,reject)=> {
//     request(config)
//       .then((response)=>{
//         if(response.data.status === OK)
//           resolve(response.data);
//         else
//           reject('Unable to get patient data')
//       })
//       .catch((err)=>{
//         reject(`Unable to get patient data: ${err}`)
//       })
//   });
// };

// export function acquireByExternalId(id) {
//   let payload = { externalId: id };
//   const config = getRequestConfig(payload,SHARE_ACQUIRE_ACTION,'/session/acquireByExternalId');
//   return new Promise((resolve,reject)=> {
//     request(config)
//       .then((response)=>{
//         if(response.data.status === OK)
//           resolve(response.data);
//         else
//           reject('Unable to share patient')
//       })
//       .catch((err)=>{
//         reject(`Unable to share patient: ${err}`)
//       })
//   });
// };

// export function provAssignmentById(obj) {
//   let payload = { assigned: obj.assigned, unassigned: obj.unassigned, patientId: obj.patientId }
//   const config = getRequestConfig(payload, ASSIGN_PROV_ACTION, '/session/provAssignmentById')
//   return new Promise((resolve, reject) => {
//     request(config)
//     .then((response) => {
//       if(response.data.status === OK)
//         resolve(response.data)
//       else
//         reject('Unable to share patient')
//     })
//     .catch((err) => {
//       reject(`Unable to assign providers: ${err}`)
//     })
//   })
// }

// export function invitePatient() {
//   let payload = {};
//   const config = getRequestConfig(payload,INVITE_PATIENT_ACTION,'/session/invitePatient');
//   return new Promise((resolve,reject)=> {
//     request(config)
//       .then((response)=>{
//         if(response.data.status === OK)
//           resolve();
//         else
//           reject('unable to invite patient')
//       })
//       .catch((err)=>{
//         reject(`unable to invite patient: ${err}`)
//       })
//   });
// };

// export function uninvitePatient() {
//   let payload = {};
//   const config = getRequestConfig(payload,UNINVITE_PATIENT_ACTION,'/session/uninvitePatient');
//   return new Promise((resolve,reject)=> {
//     request(config)
//       .then((response)=>{
//         if(response.data.status === OK)
//           resolve();
//         else
//           reject('unable to uninvite patient')
//       })
//       .catch((err)=>{
//         reject(`unable to uninvite patient: ${err}`)
//       })
//   });
// };

// export function exitPatientChart() {
//   let payload = {};
//   const config = getRequestConfig(payload,EXIT_PATIENT_CHART_ACTION,'/session/exitPatientChart');
//   // console.log(config.url)
//   return new Promise((resolve,reject)=> {
//     request(config)
//       .then((response)=>{
//         if(response.data.status === OK)
//           resolve();
//         else
//           reject('unable to exit patient chart')
//       })
//       .catch((err)=>{
//         reject(`unable to exit patient chart: ${err}`)
//       })
//   });
// };
// export function enterPatientChart(id) {
//   let payload = {
//     id
//   };
//   const config = getRequestConfig(payload, ENTER_PATIENT_CHART_ACTION, '/session/enterPatientChart');
//   return new Promise((resolve,reject)=> {
//     request(config)
//       .then((response)=>{
//         if(response.data.status === OK)
//           resolve();
//         else
//           reject('unable to enter patient chart')
//       })
//       .catch((err)=>{
//         reject(`unable to enter patient chart: ${err}`)
//       })
//   });
// };
// export let saveState = (text) => {
//   let payload = {
//     text
//   };
//   const config = getRequestConfig(payload, SAVE_STATE_ACTION, '/session/saveState');
//   return new Promise((resolve, reject) =>{
//     request(config)
//       .then((response) => {
//         if (response.data.status === OK)
//             resolve();
//         else 
//           reject(`unable to get inital message: ${err}`);
//       })
//       .catch((err) => {
//         reject(`unable to get inital message: ${err}`);
//       })
//     });
// };

// export let saveWatchList = async (text) => {
//   let payload = {
//     text
//   };
//   const config = getRequestConfig(payload, SAVE_WATCHLIST_ACTION, '/session/saveWatchList');

//   return new Promise((resolve, reject) => {
//     request(config)
//       .then((response) => {
//         if (response.data.status === OK)
//             resolve();
//         else 
//           reject(`unable to save watchlist: ${err}`);
//       })
//       .catch((err) => {
//         reject(`unable to save watchlist: ${err}`);
//       })
//     });
// };

// export function login(loginForm) {
//   const config = getRequestConfig(loginForm, LOGIN_ACTION, '/session/login');

//   return new Promise((resolve, reject) => {
//     request(config)
//       .then((response) => {
//         resolve(response.data.data);
//       })
//       .catch((err) => {
//         reject(err);
//       });
//   });
// };

// export async function logout() {
//   const config = getRequestConfig(null, LOGOUT_ACTION, '/session/logout');
//   return new Promise((resolve, reject) => {
//     axios.request(config)
//     .then((response) => {
//       resolve(response);
//     })
//     .catch((err) => {
//       reject(err);
//     })
//   });
// };

// export const getWatchList = async () => {
//   const config = getRequestConfig(null, REQUEST_WATCHLIST_ACTION);
//   return new Promise((resolve, reject) => {
//     request(config)
//     .then((response) => {
//       resolve(response.data);
//     })
//     .catch((err) => {
//       reject(err);
//     });
//   })
// };
// export const getInitialMessage = async () => {
//   const config = getRequestConfig({ action: 'requestInitialMessage' }, REQUEST_ININITIAL_MESSAGE, '/session/requestInitialMessage');
//   return new Promise((resolve, reject) => {
//     store.dispatch('login/updateCsrf',null);
//     request(config)
//     .then((response) => {
//       Vue.gotInitialMessage = true;
//       resolve(response.data.data);
//     })
//     .catch((err) => {
//       Vue.gotInitialMessage = true;
//       reject(err);
//     });
//   });  
// };
/**
 * Session related apis
 */

import axios from 'axios';
import { getRequestConfig } from './config';
import EventBus from '../event-bus';

import { 
  OK
} from './ajaxActionResponse';
import { 
 REQUEST_WATCHLIST_ACTION, SAVE_WATCHLIST_ACTION,  LOGIN_ACTION, LOGOUT_ACTION, 
 REQUEST_ININITIAL_MESSAGE, PING_ACTION, SAVE_STATE_ACTION, ENTER_PATIENT_CHART_ACTION,
 EXIT_PATIENT_CHART_ACTION, INVITE_PATIENT_ACTION, UNINVITE_PATIENT_ACTION, SHARE_ACQUIRE_ACTION,
 SHARE_SUMMARY_ACTION,
 ASSIGN_PROV_ACTION
} from './ajaxActions';
import { request, inRequest, handleSessionTimeout } from './request';

export function requestVitalSignsCodes() {
  const config = getRequestConfig(null, 'requestVitalSignsCodes', '/session/requestVitalSignsCodes');
  return new Promise((resolve, reject) => {
    request(config)
    .then((response) => {
      if (response.data.status === OK) {
        resolve(response.data.data.codes);
      } else {
        reject('Unable to retrieve vital sign codes');
      }
    })
  });
}

// payload now an optional argument; setting it to true forces a full rebuild
// of the PHR data from the server, meaning files can be pulled immediately after 
// an upload, instead of waiting for the next getAllData call.
export function getAllData(payload = null) {
  const config = getRequestConfig(payload, 'getAllData');
  return new Promise((resolve, reject) => {
    request(config)
    .then((response) => {
      const { data } = response;
      if (data) {
        resolve(data);
      } else {
        reject('Unable to retrieve application data');
      }
    })
  });
}

/**
 * Pings server to check session status 
 */
export function ping() {
  if(inRequest()) {
    return Promise.resolve();  // No-op if already in a request
  }
  const config = getRequestConfig(null, PING_ACTION, '/session/ping');
  // After capturing request, check response, and if not OK, handle session timeout
  return request(config).then((response) => {
    if (response?.data?.status === OK) {
      return;
    }
    return handleSessionTimeout();
  });
}

export function summaryByExternalId(id) {
  let payload = { externalId: id };
  const config = getRequestConfig(payload, SHARE_SUMMARY_ACTION, '/session/summaryByExternalId');
  return new Promise((resolve, reject) => {
    request(config)
      .then((response) => response.data.status === OK ? resolve(response.data) : reject('Unable to get patient data'))
      .catch(err => reject(`Unable to get patient data: ${err}`));
  });
}

export function acquireByExternalId(id) {
  let payload = { externalId: id };
  const config = getRequestConfig(payload, SHARE_ACQUIRE_ACTION, '/session/acquireByExternalId');
  return new Promise((resolve, reject) => {
    request(config)
      .then((response) => response.data.status === OK ? resolve(response.data) : reject('Unable to share patient'))
      .catch(err => reject(`Unable to share patient: ${err}`));
  });
}

export function provAssignmentById(obj) {
  let payload = { assigned: obj.assigned, unassigned: obj.unassigned, patientId: obj.patientId };
  const config = getRequestConfig(payload, ASSIGN_PROV_ACTION, '/session/provAssignmentById');
  return new Promise((resolve, reject) => {
    request(config)
    .then((response) => response.data.status === OK ? resolve(response.data) : reject('Unable to assign providers'))
    .catch(err => reject(`Unable to assign providers: ${err}`));
  });
}

export function invitePatient() {
  const config = getRequestConfig({}, INVITE_PATIENT_ACTION, '/session/invitePatient');
  return new Promise((resolve, reject) => {
    request(config)
      .then(response => response.data.status === OK ? resolve() : reject('Unable to invite patient'))
      .catch(err => reject(`Unable to invite patient: ${err}`));
  });
}

export function uninvitePatient() {
  const config = getRequestConfig({}, UNINVITE_PATIENT_ACTION, '/session/uninvitePatient');
  return new Promise((resolve, reject) => {
    request(config)
      .then(response => response.data.status === OK ? resolve() : reject('Unable to uninvite patient'))
      .catch(err => reject(`Unable to uninvite patient: ${err}`));
  });
}

export function exitPatientChart() {
  const config = getRequestConfig({}, EXIT_PATIENT_CHART_ACTION, '/session/exitPatientChart');
  return new Promise((resolve, reject) => {
    request(config)
      .then(response => response.data.status === OK ? resolve() : reject('Unable to exit patient chart'))
      .catch(err => reject(`Unable to exit patient chart: ${err}`));
  });
}

export function enterPatientChart(id) {
  const config = getRequestConfig({ id }, ENTER_PATIENT_CHART_ACTION, '/session/enterPatientChart');
  return new Promise((resolve, reject) => {
    request(config)
      .then(response => response.data.status === OK ? resolve() : reject('Unable to enter patient chart'))
      .catch(err => reject(`Unable to enter patient chart: ${err}`));
  });
}

// Enter chart then rebuild PHR so CDAs and other cached documents match the patient.
export async function enterPatientChartAndRefresh(id) {
  try {
    await enterPatientChart(id);
    // Rebuild PHR so CDAs and other cached documents match the patient whose chart is open.
    const newData = await getAllData({ rebuild: true });
    // Commit that new data into your Vuex store using the LoggedIn mutation
    // which sets both phrData and loggedIn flag
    store.commit('login/LoggedIn', { data: newData });
    return newData;
  } catch (error) {
    throw error;
  }
}


export let saveState = (text) => {
  const config = getRequestConfig({ text }, SAVE_STATE_ACTION, '/session/saveState');
  return new Promise((resolve, reject) => {
    request(config)
      .then(response => response.data.status === OK ? resolve() : reject('Unable to save state'))
      .catch(err => reject(`Unable to save state: ${err}`));
  });
};

export let saveWatchList = async (text) => {
  const config = getRequestConfig({ text }, SAVE_WATCHLIST_ACTION, '/session/saveWatchList');
  return new Promise((resolve, reject) => {
    request(config)
      .then(response => response.data.status === OK ? resolve() : reject('Unable to save watchlist'))
      .catch(err => reject(`Unable to save watchlist: ${err}`));
  });
};

export function login(loginForm) {
  console.log("sessionApi.login called with:", loginForm);
  const config = getRequestConfig(loginForm, LOGIN_ACTION, '/session/login');
  return new Promise((resolve, reject) => {
    request(config)
      .then(response => {
        // console.log(response)
        resolve(response.data.data)})
      .catch(err => reject(err));
  });
}

export async function logout() {
  const config = getRequestConfig(null, LOGOUT_ACTION, '/session/logout');
  return request(config);
}

export const getWatchList = async () => {
  const config = getRequestConfig(null, REQUEST_WATCHLIST_ACTION);
  return new Promise((resolve, reject) => {
    request(config)
      .then(response => resolve(response.data))
      .catch(err => reject(err));
  });
};

export const getInitialMessage = async () => {
  const config = getRequestConfig({ action: 'requestInitialMessage' }, REQUEST_ININITIAL_MESSAGE, '/session/requestInitialMessage');
  return new Promise((resolve, reject) => {
    request(config)
      .then((response) => {
        EventBus.emit('gotInitialMessage', true);  // ? Use eventBus instead of Vue
        resolve(response.data.data);
      })
      .catch((err) => {
        EventBus.emit('gotInitialMessage', true);  // ? Use eventBus instead of Vue
        reject(err);
      });
  });  
};
